// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/vertexai';
import { ɵzoneWrap } from '@angular/fire';
import {
  getGenerativeModel as _getGenerativeModel,
  getVertexAI as _getVertexAI
} from 'firebase/vertexai';

export const getGenerativeModel = ɵzoneWrap(_getGenerativeModel, true);
export const getVertexAI = ɵzoneWrap(_getVertexAI, true);
